import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { get, omit } from 'lodash';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';

import { AnalyticsContext } from './AnalyticsProvider';

import logger from 'itrvl-logger';
const log = logger(__filename);

export class TrackedButton extends Component {
  static contextType = AnalyticsContext;

  static propTypes = {
    analyticsProperties: PropTypes.object,
    location: PropTypes.object,
  };

  onClick = (...args) => {
    const props = get(this.props, 'analyticsProperties', {});
    props.location = this.props.location.pathname;

    log.trace('track', props);
    this.context.analytics().track('click', props);

    if (this.props.onClick) {
      log.trace('click', ...args);
      this.props.onClick(...args);
    }
  };

  render() {
    const props = omit(this.props, ['analyticsProperties', 'onClick', 'location', 'history', 'match', 'staticContext', 'tooltipTitle']);
    const tooltipTitle = get(this.props, 'tooltipTitle', '');

    let result = (
      <Button onClick={this.onClick} {...props}>
        {this.props.children}
      </Button>
    );
    if (tooltipTitle !== '') {
      result = (
        <Tooltip title={<Typography data-test-id="button-tooltip">{tooltipTitle}</Typography>}>
          <span>{result}</span>
        </Tooltip>
      );
    }
    return result;
  }
}

export default withRouter(TrackedButton);
